import { render, staticRenderFns } from "./OrganizationPhoneNumberTable.vue?vue&type=template&id=7eb732e2&"
import script from "./OrganizationPhoneNumberTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPhoneNumberTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports